module.exports = __webpack_public_path__ + "img/17845_S.c4e770bf.png";